// extracted by mini-css-extract-plugin
export default {"ordersContainer":"OrdersPage_ordersContainer__rTyhd"};